<template>
  <img 
    :src="logoSrc" 
    :alt="altText"
    :class="className" 
    :style="styles"
    loading="lazy"
  />
</template>

<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { FriendlierPrimaryOcean, FriendlierPrimaryCloud, FramiePrimaryOcean, FramiePrimaryCloud } from '@/revamp/assets/images/logos';
import { FriendlierSecondaryOceanLogo, FramieSecondaryOceanLogo, FriendlierSecondaryCloudLogo, FramieSecondaryCloudLogo } from '@/assets/logos';

// type LogoVariant = 'primary' | 'secondary';
// type LogoColor = 'ocean' | 'cloud';

const props = defineProps({
  variant: {
    type: String,
    default: 'primary',
    validator: (value) => ['primary', 'secondary'].includes(value),
  },
  color: {
    type: String,
    default: 'ocean',
    validator: (value) => ['ocean', 'cloud'].includes(value),
    default: 'ocean'
  },
  className: {
    type: String,
    default: ''
  },
  styles: {
    type: Object,
    default: () => ({}),
  }
});

const { locale } = useI18n();

const logoMap = {
  en: {
    primary: {
      ocean: FriendlierPrimaryOcean,
      cloud: FriendlierPrimaryCloud,
    },
    secondary: {
      ocean: FriendlierSecondaryOceanLogo,
      cloud: FriendlierSecondaryCloudLogo
    },
  },
  fr: {
    primary: {
      ocean: FramiePrimaryOcean,
      cloud: FramiePrimaryCloud,
    },
    secondary: {
      ocean: FramieSecondaryOceanLogo,
      cloud: FramieSecondaryCloudLogo,
    },
  },
};

const logoSrc = computed(() => {
  const currentLocale = locale.value === 'fr' ? 'fr' : 'en';
  return logoMap[currentLocale]?.[props.variant]?.[props.color] ?? logoMap.en.primary.ocean;
});

const altText = computed(() => {
  const brand = locale.value === 'fr' ? 'Framie' : 'Friendlier';
  const variantText = props.variant === 'secondary' ? 'secondary ' : '';
  return `${brand} ${variantText}logo`;
});
</script>

<style scoped lang="scss">
</style>